<template>
    <div class="profile-page">
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0 pt-5 pb-200">
                <div class="shape shape-style-0 shape-red ">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2 class="display-2  text-white">3Z Automation LLC
                                    <span>Contact Us</span>
                                </h2>
                                <!-- <p class="lead  text-white">2014 Platinum St. Garland TX 75042</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--200" no-body>
                    <div class="px-4">
                        <div class="row justify-content-center pb-4">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/brand/3Zlogo_big.png'" class="rounded bgw">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                                <div class="card-profile-actions py-4 mt-lg-0">
                                    <!-- <base-button type="primary" size="sm" class="mr-4">Connect</base-button>
                                    <base-button type="default" size="sm" class="">Message</base-button> -->
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-1">
                                <div class="card-profile-stats d-flex justify-content-center">
                                    <div>
                                        <span class="heading"></span>
                                        <span class="description"></span>
                                    </div>
                                    <div>
                                        <span class="heading"></span>
                                        <span class="description"></span>
                                    </div>
                                    <div>
                                        <span class="heading"></span>
                                        <span class="description"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>3Z Automation
                                <span class="font-weight-light"> LLC</span>
                            </h3>
                            <!-- <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Location, TX</div> -->
                            <div class="h6 mt-4"><icon name="fa fa-map-marker"  color="red"></icon> 2014 Platinum St. Garland TX 75042</div>
                            <div class="h6 mt-4"><icon name="fa fa-phone"  color="red"></icon> Tel:(972) 276-1641</div>
                            <div class="h6 mt-4"><icon name="fa fa-fax"  color="red"></icon> Fax:(972) 276-5341</div>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-6">
                                    <p><icon name="fa fa-compass" color="red"></icon> Webiste: www.3zautomation.com</p>
                                    <!-- <a href="#">Show more</a> -->
                                </div>
                                <div class="col-lg-6">
                                    <p><icon name="fa fa-envelope" color="red"></icon> Email: 3z.info@3zautomation.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.bgw {
    background: #fff;
}
</style>
